import React from "react";
import InfoTile from "./InfoTile";
import AppActionButton from "./AppActionButton";
import {AvailableAppDetailsResponse} from "../../../logic/APITypes";

type AvailableAppTileProps = {
  appDetails: AvailableAppDetailsResponse;
  groupId: string;
  isGroupAdmin: boolean;
  appId: string;
};

/** Tile specific to available (not installed) applications */
function AvailableAppTile({
  appDetails,
  groupId,
  isGroupAdmin,
  appId,
}: AvailableAppTileProps) {
  return (
    <InfoTile
      currentVersion={undefined}
      latestVersion={appDetails.app_version}
      homeUrl={appDetails.home_url}
    >
      <AppActionButton
        groupId={groupId}
        isGroupAdmin={isGroupAdmin}
        appId={appId}
        status="available"
        requiresParameters={appDetails.requires_parameters}
      />
    </InfoTile>
  );
}

export default AvailableAppTile;
